export enum TRANSACTION_TYPE {
  NEW_BUSINESS = 'NB',
  RENEWAL = 'R',
  ENDORSEMENT = 'E',
  CANCELLATION = 'C',
}
